import { ThemeOptions } from '@mui/material/styles/createTheme';
import { palette } from './palette';

export const darkTheme: ThemeOptions = {
  palette,
};
